import React from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';

import { ITeamMember } from '@types';
import { formatDate } from '@utils';
import { listCardSx } from 'theme/surfaces';
import { TeamsTableHeader } from '../constants/headers';
import { isSowEndingSoon } from './helpers';
import { TeamMember } from './TeamMember';

const SOW_DATE_FORMAT = 'd MMM yyyy';

type Props = {
  member: ITeamMember;
  projectId: string;
  visibleHeaders: TeamsTableHeader[];
};

export const MemberCard: React.FC<Props> = ({
  member,
  projectId,
  visibleHeaders,
}) => (
  <Card
    variant="outlined"
    sx={{
      ...listCardSx,
      py: 1.5,
      position: 'relative',
      '& a::after': { content: '""', position: 'absolute', inset: 0 },
    }}
  >
    <Stack gap={1.5}>
      <TeamMember teamMember={member} projectId={projectId} />

      <Box display="flex" alignItems="center" columnGap={2} flexWrap="wrap">
        <Typography variant="body2" flexGrow={1}>
          SOW: {formatDate(member.startedAt, SOW_DATE_FORMAT) || '-'} –{' '}
          <Typography
            component="span"
            variant="body2"
            color={isSowEndingSoon(member.endedAt) ? 'error.main' : undefined}
          >
            {formatDate(member.endedAt, SOW_DATE_FORMAT) || '-'}
          </Typography>
        </Typography>

        {visibleHeaders.includes(TeamsTableHeader.Rate) && (
          <Typography variant="body2">
            <Typography component="span" variant="body2" color="text.disabled">
              $
            </Typography>
            {member.rate}
          </Typography>
        )}

        {visibleHeaders.includes(TeamsTableHeader.Allocation) && (
          <Typography variant="body2">{`${member.allocation}%`}</Typography>
        )}
      </Box>
    </Stack>
  </Card>
);
